import { format, parseISO } from 'date-fns';
import i18n, { dateFnsLocale } from '@/i18n';

export function useFormatTimestamp() {
  const formatTimestamp = (timestamp, includeTime = true) => {
    const date = parseISO(timestamp);
    const locale = dateFnsLocale();
    if (includeTime) {
      // e.g. "02.02.2026 kell 14:30" / "02.02.2026 at 14:30"
      const at = i18n.global.t('common.at');
      return format(date, `dd.MM.yyyy '${at}' HH:mm`, { locale });
    } else {
      return format(date, 'dd.MM.yyyy', { locale });
    }
  };

  return { formatTimestamp };
}
